import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import plusCirclePath from '@starbucks-web/pattern-library/lib/icons/plus-circle';
import plusCircleSolidPath from '@starbucks-web/pattern-library/lib/icons/plus-circle-solid';

import StepperIconButton from './stepper-icon-button';
import messages from './messages';

const PlusButton = forwardRef(
  (
    {
      accessibleLabelId,
      currentQuantity,
      defaultQuantity,
      inRecipe,
      modifiedFromDefault,
      onClick = () => {},
      onValueChange,
      productOptionName,
    },
    ref
  ) => {
    const { formatMessage } = useIntl();
    const increaseQuantity = () => {
      // if there's a default quantity, that should be what comes up on initial
      // add by the customer. Otherwise, default to 1.
      onValueChange?.(
        !currentQuantity ? defaultQuantity || 1 : currentQuantity + 1
      );
      onClick();
    };

    const getAriaLabel = () => {
      if (!currentQuantity) {
        if (inRecipe) {
          return formatMessage(messages.addQuantityText, {
            productOptionName,
          });
        }
        return undefined;
      }
      return formatMessage(messages.increaseQuantityMessage);
    };

    return (
      <StepperIconButton
        ariaDescribedBy={
          !currentQuantity && !inRecipe ? undefined : accessibleLabelId
        }
        ariaLabel={getAriaLabel()}
        ariaLabelledBy={
          !currentQuantity && !inRecipe ? accessibleLabelId : undefined
        }
        onClick={increaseQuantity}
        path={modifiedFromDefault ? plusCircleSolidPath : plusCirclePath}
        ref={ref}
      />
    );
  }
);

export default PlusButton;
